import { Modal, Checkbox, Button, LoadingOverlay } from '@mantine/core';
import ModalComponent from '../../../components/modal';
import { Language } from '../../../languages/languageHandler';
import { useEffect, useState } from 'react';
import { IntializationHelpdeskEquipment } from '../../../../libraries/helpdesk/equipments';
import CustomModal from '../../../components/custom-modal';
import './styles.scss';

interface ModalProps {
  isOpen: boolean;
  hideBtn: () => void;
  lang: Language;
  eid: number;
  isInitAccepted: boolean;
  autorizeInitialization: () => void;
}

const AutorizeInitializationModal = ({
  isOpen,
  hideBtn,
  lang,
  eid,
  isInitAccepted,
  autorizeInitialization
}: ModalProps) => {
  const [initAccepted, setInitAccepted] = useState(isInitAccepted);
  const [loading, setLoading] = useState(false);

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setInitAccepted(isInitAccepted);
  }, [isInitAccepted]);

  const handleSave = async () => {
    const controller = new AbortController();
    setLoading(true);
    try {
      const response = await IntializationHelpdeskEquipment({ eid, initAccepted }, controller);

      if (response.statusOper && response.statusOper.code === 0) {
        setSuccessMessage(lang.EQUIPMENT_AUTHORIZE_INITIALIZATION_SUCCESS || 'Operation completed');
        setShowSuccess(true);

        setTimeout(() => {
          autorizeInitialization();
          hideBtn();
        }, 1500);
      } else {
        const code = response.statusOper?.code ?? 'Unknown';
        setErrorMessage(`${lang.EQUIPMENT_AUTHORIZE_INITIALIZATION_ERROR || 'Operation failed'} (Code: ${code})`);
        setShowError(true);

        setTimeout(() => setShowError(false), 3000);
      }
    } catch (error) {
      console.error('Initialization failed:', error);
      setErrorMessage(lang.EQUIPMENT_AUTHORIZE_INITIALIZATION_ERROR || 'Operation failed');
      setShowError(true);
      setTimeout(() => setShowError(false), 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ModalComponent
        show={isOpen}
        handleClick={hideBtn}
        title={`${lang.EQUIPMENT_AUTHORIZE_INITIATION} - ${eid}`}
        classname="autorize-initialization"
        content={
          <Modal.Body style={{ margin: 0, padding: 0 }}>
            <LoadingOverlay visible={loading} />
            <Checkbox
              label={lang.EQUIPMENT_AUTHORIZE_INITIATION || 'Initialization Accepted'}
              checked={initAccepted}
              onChange={event => setInitAccepted(event.currentTarget.checked)}
            />
            <Button radius="md" onClick={handleSave} disabled={loading}>
              {lang.GLOBAL_SAVE_BUTTON || 'Save'}
            </Button>
          </Modal.Body>
        }
      />

      <CustomModal
        opened={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={successMessage}
        backgroundColor="#28a745"
        textColor="white"
      />

      <CustomModal
        opened={showError}
        onClose={() => setShowError(false)}
        message={errorMessage}
        backgroundColor="#E3353F"
        textColor="white"
      />
    </>
  );
};

export default AutorizeInitializationModal;
